import { ChangeEvent } from "react";

import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { ComboBoxDropDownItem } from "./Combobox";

interface ISelectLookupControlProps {
    Id?: string;
    dataCy?: string;
    Operation?: number;
    Callback?: any;
    Value: string;
    AvailableValues: ComboBoxDropDownItem[];
    IncludeEmptyChoice?: boolean;
    Placeholder?: string;
    Item?: any
    style?: any;
    disabled?: boolean;
    invalid?: boolean;
    className?: string;
}

class SelectLookupControl extends React.Component<ISelectLookupControlProps, any> {
    public render(): JSX.Element {
        let values: ComboBoxDropDownItem[] = [];
        if (this.props.AvailableValues && this.props.AvailableValues.length > 0) {
            values = this.props.AvailableValues.map(x => MyleHelper.CloneObject(x));
            if (this.props.IncludeEmptyChoice && values) {
                if (values.filter(x => x.Code == "").length == 0)
                    values.unshift(new ComboBoxDropDownItem("", "", 0));
            }
        }

        var isDisabled = false;
        isDisabled = this.props != null && this.props.disabled;

        let classname = `${this.props.className ?? ""} form-control myle-control`;
        if (this.props.invalid)
            classname += " invalid";

        return (
            <select
                data-cy={this.props.dataCy}
                disabled={isDisabled}
                style={this.props.style}
                onChange={this.OnValueChanged.bind(this)}
                className={classname}
                value={this.props.Value}
                placeholder={this.props.Placeholder}
            >
                {values.map((p, idx) => <option key={p.Code + idx} value={p.Code} hidden={p.Hidden}>{p.DisplayName}</option>)}
            </select>

        );
    }

    private OnValueChanged(e: ChangeEvent<HTMLSelectElement>): void {
        if (!(this.props.Operation == null)) {
            var operation = new LocalEvent(this.props.Operation);

            operation.AddItem("value", e.target.value);
            operation.AddItem("item", this.props.Item);
            LocalEventDispatcher.dispatch(operation);
        }
        else if (!(this.props.Callback == null)) {
            this.props.Callback(e.target.value, this.props.Item);
        }
    }
}

export { ISelectLookupControlProps, SelectLookupControl };
